// eslint-disable-next-line no-undef
const MeowSettings = mwl_settings;
const selector = MeowSettings.settings.selector;
const anti_selector = MeowSettings.settings.anti_selector;
const theme = MeowSettings.settings.theme;
const slideshow = {
  enabled: MeowSettings.settings.slideshow.enabled,
  slide_duration: MeowSettings.settings.slideshow.timer,
};
// Still in development
const thumbnails_navigation = {
  enabled: false,
  height: 200,
};
const preloading = MeowSettings.settings.preloading; // not in use;
const magnification = {
  enabled: MeowSettings.settings.magnification,
};
const backdrop_opacity = MeowSettings.settings.backdrop_opacity;
const map = MeowSettings.settings.map;
const caption_source = MeowSettings.settings.caption_source;
const caption_ellipsis = MeowSettings.settings.caption_ellipsis;
const low_res_placeholder = MeowSettings.settings.low_res_placeholder;
const wordpress_big_image = MeowSettings.settings.wordpress_big_image;
const deep_linking = MeowSettings.settings.deep_linking;
const disable_scroll = true;
const social_sharing = MeowSettings.settings.social_sharing;
const separate_galleries = MeowSettings.settings.separate_galleries;
const animation_toggle = MeowSettings.settings.animation_toggle;
const animation_speed = MeowSettings.settings.animation_speed;
const infos_to_display = {
  title: MeowSettings.settings.exif.title,
  caption: MeowSettings.settings.exif.caption,
  camera: MeowSettings.settings.exif.camera,
  date: MeowSettings.settings.exif.date,
  lens: MeowSettings.settings.exif.lens,
  shutter_speed: MeowSettings.settings.exif.shutter_speed,
  aperture: MeowSettings.settings.exif.aperture,
  focal_length: MeowSettings.settings.exif.focal_length,
  iso: MeowSettings.settings.exif.iso,
  keywords: MeowSettings.settings.exif.keywords,
};
const download = {
  enabled: MeowSettings.settings.download_link,
};
const right_click_protection = MeowSettings.settings.right_click_protection;

const animation_speeds = {
  very_fast: 150,
  fast: 300,
  normal: 500,
  slow: 700,
  very_slow: 1000,
}

export { selector, anti_selector, theme, slideshow, thumbnails_navigation, preloading,
  magnification, backdrop_opacity, map, caption_source, caption_ellipsis, low_res_placeholder, wordpress_big_image, deep_linking, disable_scroll,
  social_sharing, separate_galleries, animation_toggle, animation_speed, animation_speeds, infos_to_display, download, right_click_protection };